import Cookies from 'js-cookie';

export default function leadCaptured() {
  Livewire.on('addCapturedReport', (capturedReports) => {
    Cookies.set('captured_reports', capturedReports, 1825);
  });
}
